import { useTranslation } from 'react-i18next';
import { ButtonType } from 'yoda-ui/components/Button/Button.types';

const TacticValidationDialogConfig = (
  handleCloseDialog: Function,
  handleSubmitDialog: Function,
) => {
  const { t } = useTranslation();

  const actionsButtonConfig = {
    cancelButtonConfig: {
      buttonProps: {
        onClick: () => handleCloseDialog(),
        buttonType: ButtonType.secondary,
      },
      label: t('maya_tactic_validation_form_cancel_button'),
    },
    submitButtonConfig: {
      buttonProps: {
        onClick: () => handleSubmitDialog(),
        buttonType: ButtonType.neutral,
      },
      label: t('maya_tactic_validation_form_submit_button'),
    },
    removeButtonConfig: {
      buttonProps: {
        onClick: () => handleSubmitDialog(),
        buttonType: ButtonType.neutral,
      },
      label: t('maya_tactic_validation_form_remove_button'),
    },
  };

  return {
    actionsButtonConfig,
  };
};

export default TacticValidationDialogConfig;
